import * as React from "react";

import { cn } from "@immi/ui/lib/utils";

type TextareaProps = React.ComponentProps<"textarea"> & {
  /**
   * Grows with the content (`field-sizing: content`) up to `max-h-80`, then
   * scrolls. Off → a classic fixed-rows textarea the user resizes.
   */
  autoGrow?: boolean;
};

function Textarea({ className, autoGrow = true, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        autoGrow && "[field-sizing:content] max-h-80 resize-none",
        "focus-visible:border-primary-600 focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
export type { TextareaProps };
